/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export type InviteClientResult = {
    email: string;
    status: InviteClientResult.status;
};
export namespace InviteClientResult {
    export enum status {
        INVITED = 'invited',
        ALREADY_INVITED_RESENT = 'already-invited-resent',
        ALREADY_INVITED_RATE_LIMITED = 'already-invited-rate-limited',
        ALREADY_HAS_ACCOUNT = 'already-has-account',
        SEND_FAILED = 'send-failed',
    }
}

